// Ornate gold mandala line pattern — symmetrical from center.
// Colour is inherited via `currentColor`; control opacity from the parent.
export const Mandala = ({ className = "", style }) => {
  const outerPetals = Array.from({ length: 24 });
  const innerPetals = Array.from({ length: 12 });
  const dots = Array.from({ length: 24 });

  return (
    <svg
      viewBox="0 0 800 800"
      className={className}
      style={style}
      aria-hidden="true"
      focusable="false"
    >
      <g fill="none" stroke="currentColor" strokeWidth="1">
        <circle cx="400" cy="400" r="52" />
        <circle cx="400" cy="400" r="104" strokeDasharray="2 7" />
        <circle cx="400" cy="400" r="188" />
        <circle cx="400" cy="400" r="262" strokeDasharray="1 9" />
        <circle cx="400" cy="400" r="332" />
        <circle cx="400" cy="400" r="392" strokeDasharray="3 10" />

        {outerPetals.map((_, i) => (
          <g key={`op-${i}`} transform={`rotate(${(360 / 24) * i} 400 400)`}>
            <path d="M400 138 C 432 208, 432 252, 400 302 C 368 252, 368 208, 400 138 Z" />
          </g>
        ))}

        {innerPetals.map((_, i) => (
          <g key={`ip-${i}`} transform={`rotate(${(360 / 12) * i + 15} 400 400)`}>
            <path d="M400 296 Q 417 338 400 382 Q 383 338 400 296 Z" />
          </g>
        ))}

        {outerPetals.map((_, i) => (
          <g key={`lp-${i}`} transform={`rotate(${(360 / 24) * i + 7.5} 400 400)`}>
            <path d="M400 66 Q 410 96 400 122 Q 390 96 400 66 Z" />
          </g>
        ))}

        {dots.map(
          (_, i) =>
            i % 2 === 0 && (
              <circle
                key={`dot-${i}`}
                cx="400"
                cy="34"
                r="2.4"
                fill="currentColor"
                stroke="none"
                transform={`rotate(${(360 / 24) * i} 400 400)`}
              />
            ),
        )}

        <circle cx="400" cy="400" r="10" fill="currentColor" stroke="none" opacity="0.7" />
      </g>
    </svg>
  );
};
